import { render, staticRenderFns } from "./RmaFilters.vue?vue&type=template&id=634cbc7a&"
import script from "./RmaFilters.vue?vue&type=script&lang=js&"
export * from "./RmaFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports